import { render, staticRenderFns } from "./link.vue?vue&type=template&id=a3cc3bca&scoped=true&"
import script from "./link.vue?vue&type=script&lang=js&"
export * from "./link.vue?vue&type=script&lang=js&"
import style0 from "./link.vue?vue&type=style&index=0&id=a3cc3bca&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cc3bca",
  null
  
)

export default component.exports